import { merge } from 'lodash';

// toStringFilterValue returns a type conversion for a filter panel's props converting from non-string values to
// string values.
//
// For instance, converting the inputs and outputs of the checkbox filter from/to boolean.
export const toStringFilterValue = ({fromStringValue, toStringValue = v => v.toString()}) =>
  propsWithNonStringValues =>
    merge({},
      propsWithNonStringValues,
      {
        value: (propsWithNonStringValues.value || []).map(toStringValue),

        addSelection: ({questionId, type, value}) =>
          propsWithNonStringValues.addSelection({
            questionId,
            type,
            value: value.map(fromStringValue)
          }),
      });

export default toStringFilterValue;
